import ListItemIcon from "@mui/material/ListItemIcon";
import EditIcon from "@mui/icons-material/Edit";
import MovingIcon from "@mui/icons-material/Moving";
import { useTheme } from "@emotion/react";

export function useItemOptions() {
  const theme = useTheme();

  return [
    {
      label: "עריכה",
      icon: (
        <ListItemIcon sx={{ color: theme.colors.main_color }}>
          <EditIcon fontSize="small" />
        </ListItemIcon>
      ),
      href: "",
    },
    {
      label: "תנועות",
      icon: (
        <ListItemIcon sx={{ color: theme.colors.main_color }}>
          <MovingIcon fontSize="small" />
        </ListItemIcon>
      ),
      href: "journal-entries",
    },
  ];
}
